import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Flex, Text } from '@chakra-ui/react';
import { ModalComponent } from '../../../../components/Modal/modal';
import { Button } from '../../../../components/button/button';
import { togglePublishModal } from '../../../../actions/dictionary-values';
import Input from '../../../../components/input/input';
import { InputVariant } from '../../../../core/enums';
import './publish-modal.scss';
export const PublishModal = (props)=>{
    const { publish, associatedDictionaries } = props;
    const [jiraTicket, setJiraTicket] = useState('');
    const [publishDisabled, setPublishDisabled] = useState(true);
    const [jiraTicketError, setJiraTicketError] = useState(false);
    const jiraTicketRegex = /^[a-zA-Z]+-\d+$/;
    useEffect(()=>{
        if (jiraTicket.length >= 5 && jiraTicket.length <= 20) {
            setPublishDisabled(false);
        } else {
            setPublishDisabled(true);
        }
    }, [
        jiraTicket
    ]);
    const dispatch = useDispatch();
    const _handleClose = ()=>{
        setJiraTicketError(false);
        dispatch(togglePublishModal(false));
    };
    const _handlePublish = ()=>{
        setJiraTicketError(false);
        if (jiraTicketRegex.test(jiraTicket)) {
            publish(associatedDictionaries, jiraTicket);
            dispatch(togglePublishModal(false));
        } else {
            setJiraTicketError(true);
        }
    };
    return /*#__PURE__*/ _jsx(ModalComponent, {
        size: 'xl',
        isOpen: true,
        handleClose: _handleClose,
        modalHeader: /*#__PURE__*/ _jsx(Text, {
            children: "Confirm Dictionary Publish"
        }),
        modalContent: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    children: "Enter Jira Ticket associated with this change."
                }),
                jiraTicketError ? /*#__PURE__*/ _jsx(Text, {
                    className: 'jiraTicketError',
                    children: "Please enter a valid Jira Ticket (e.g. PROJECT-XXX)"
                }) : '',
                /*#__PURE__*/ _jsx(Input, {
                    className: 'jiraTicketField',
                    autoFocus: true,
                    variant: InputVariant.TEXT,
                    label: '',
                    placeholder: 'Ticket #',
                    onChange: (e)=>setJiraTicket(e.target.value),
                    dataTestId: 'jiraTicketInput'
                })
            ]
        }),
        modalFooter: /*#__PURE__*/ _jsxs(Flex, {
            columnGap: '8px',
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    label: 'Cancel',
                    onClick: _handleClose,
                    name: 'Cancel',
                    dataTestId: 'Cancel'
                }),
                ' ',
                /*#__PURE__*/ _jsx(Button, {
                    label: 'Publish',
                    dataTestId: 'publishBtn',
                    name: 'Publish',
                    disabled: publishDisabled,
                    onClick: ()=>_handlePublish()
                })
            ]
        })
    });
};
